module.exports = __webpack_public_path__ + "img/top-banner.759dcd97.png";